// extracted by mini-css-extract-plugin
export var toggled = "ItemWithMenu-module--toggled--CzeA1";
export var wrapper = "ItemWithMenu-module--wrapper--qjUzQ";
export var wrapper__container = "ItemWithMenu-module--wrapper__container--paHeN";
export var wrapper__container__icon = "ItemWithMenu-module--wrapper__container__icon--NQfIa";